import { axios } from '@/lib/axios';

export const readNotificationsAgency = (id: string) => {
  const payload = {
    id: id,
  };
  return axios.post('/agency-api/agency-read-notifications', payload);
};
